export const comments_3281820 = {"data":{"data":[],"links":{}}}